import vClickOutside from 'v-click-outside'
import { mapGetters } from 'vuex'

import { icArrowSmallUp, icArrowSmallDown } from '@vivareal/lina-icons'

import formatDecimal from '@/filters/format-decimal'

import ozIconRemoveFilter from '@/pages/results/components/filters/oz-icon-remove-filter'
import { maskNumberInput } from '@/lib/mask'

export default {
  name: 'oz-areas',

  props: {
    min: { type: [Number, String] },
    max: { type: [Number, String] },
    isPill: { type: Boolean },
  },

  data () {
    return {
      open: false,
      firstOpen: true,
      filters: {
        usableAreasMin: (this.min || '').toString(),
        usableAreasMax: (this.max || '').toString(),
      },
      title: '',
      maxLength: 6,
    }
  },

  watch: {
    min (value) {
      if (value === this.filters.usableAreasMin) return
      this.filters.usableAreasMin = value
      this.setTitle()
    },

    max (value) {
      if (value === this.filters.usableAreasMax) return
      this.filters.usableAreasMax = value
      this.setTitle()
    },
  },

  computed: {
    ...mapGetters(['isMobile']),
    usableAreasMin: maskNumberInput('filters.usableAreasMin'),
    usableAreasMax: maskNumberInput('filters.usableAreasMax'),
    titleColor () {
      return this.open || (this.filters.usableAreasMin || this.filters.usableAreasMax) ? 'primary' : 'dark'
    },

    iconColor () {
      return this.open ? 'primary' : 'dark'
    },

    icon () {
      return this.open ? icArrowSmallUp : icArrowSmallDown
    },

    maxValue () {
      const { usableAreasMin: min, usableAreasMax: max } = this.filters
      return min && max ? max : undefined
    },

    minValue () {
      const { usableAreasMin: min, usableAreasMax: max } = this.filters
      return min && max ? min : undefined
    },
  },

  created () {
    this.setTitle()
  },

  methods: {
    toggleOptions () {
      this.open = !this.open

      if (!this.open) {
        this.setTitle()
        this.updateFilter()
      }
    },

    closeOptions () {
      const noArea = this.usableAreasMax === '' && this.usableAreasMin === ''

      if (!this.isMobile && this.open) {
        this.open = false
        this.setTitle()

        if (noArea && this.firstOpen) {
          this.firstOpen = false
          return
        }

        this.updateFilter()
      }
    },

    updateFilter () {
      this.$emit('filters:update', this.filters)
    },

    onInputChange () {
      if (this.isMobile) {
        this.updateFilter()
      }
    },

    removeFilter () {
      this.filters = {
        usableAreasMin: undefined,
        usableAreasMax: undefined,
      }

      this.$emit('filters:update', this.filters, 'usableAreas')
    },

    setTitle () {
      const { usableAreasMin, usableAreasMax } = this.filters
      let title = 'área (m²)'

      const min = formatDecimal({ value: usableAreasMin || 0 })
      const max = formatDecimal({ value: usableAreasMax || 0 })

      if (usableAreasMin && usableAreasMax) title = `${min} - ${max}m²`
      else if (usableAreasMin) title = `Acima de ${min}m²`
      else if (usableAreasMax) title = `Até ${max}m²`

      this.title = title
    },
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: { ozIconRemoveFilter },
}
